module.exports = "/images/Kid rides.svg?53dd4b619e4b90945510cab8aa3a65f4";